import { api } from '@/config/api';

export type TemplateEntityType = 'contact' | 'lead' | 'deal';
// Must match CUSTOM_FIELD_KINDS in backend/src/schemas/custom-field-definition.schema.ts —
// the template DTO rejects anything else.
export type TemplateFieldKind =
  | 'text' | 'long_text' | 'number' | 'currency' | 'date' | 'datetime'
  | 'dropdown' | 'multi_select' | 'boolean' | 'url' | 'email' | 'phone';

export type IndustryStatus = 'not_started' | 'in_progress' | 'done';

export interface TemplateField {
  entityType: TemplateEntityType;
  name: string;
  key: string;
  kind: TemplateFieldKind;
  options?: string[];
  required?: boolean;
  order?: number;
  helpText?: string;
  placeholder?: string;
  defaultValue?: string;
}

export interface IndustryTemplate {
  _id?: string;
  industryKey: string;
  label: string;
  fields: TemplateField[];
  isActive?: boolean;
  status?: IndustryStatus;
  statusUpdatedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const industryConfigsService = {
  list: async (): Promise<IndustryTemplate[]> =>
    (await api.get('/super_admin/industry-configs')).data,
  /** Companies (not deleted) per assigned industry key. */
  usage: async (): Promise<Record<string, number>> =>
    (await api.get('/super_admin/industry-configs/usage')).data,
  get: async (industryKey: string): Promise<IndustryTemplate> =>
    (await api.get(`/super_admin/industry-configs/${industryKey}`)).data,
  upsert: async (industryKey: string, payload: { label: string; fields: TemplateField[]; isActive?: boolean }): Promise<IndustryTemplate> =>
    (await api.put(`/super_admin/industry-configs/${industryKey}`, payload)).data,
  setStatus: async (industryKey: string, status: IndustryStatus, label: string): Promise<IndustryTemplate> =>
    (await api.patch(`/super_admin/industry-configs/${industryKey}/status`, { status, label })).data,
  remove: async (industryKey: string) =>
    (await api.delete(`/super_admin/industry-configs/${industryKey}`)).data,
  applyToCompany: async (industryKey: string, companyUid: string): Promise<{ copied: number; skipped: number }> =>
    (await api.post(`/super_admin/industry-configs/${industryKey}/apply/${companyUid}`)).data,
};
